import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtMoney } from "@/lib/api";
import KanbanBoard from "@/components/KanbanBoard";
import DealsTable from "@/components/DealsTable";
import ViewToggle from "@/components/ViewToggle";
import ReferralLinkCard from "@/components/ReferralLinkCard";

function Datum({ label, value, sub }) {
  return (
    <div>
      <div className="small-caps text-slate-500">{label}</div>
      <div className="mt-3 font-semibold text-[40px] leading-none text-[#1F2937]">{value}</div>
      {sub && <div className="mt-2 small-caps text-slate-400">{sub}</div>}
    </div>
  );
}

export default function BrokerDashboard() {
  const [metrics, setMetrics] = useState({});
  const [view, setView] = useState(() => localStorage.getItem("vn_pipeline_view") || "table");
  useEffect(() => localStorage.setItem("vn_pipeline_view", view), [view]);
  useEffect(() => {
    api.get("/metrics/broker").then((r) => setMetrics(r.data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-[1200px] space-y-16" data-testid="broker-dashboard">
      <header className="flex items-end justify-between flex-wrap gap-6">
        <div>
          <div className="small-caps text-slate-500">Your advisor desk</div>
          <h1 className="mt-6 font-semibold text-[72px] leading-[0.9] tracking-tight text-[#1F2937]">
            Your <span className="italic">submissions.</span>
          </h1>
        </div>
        <Link to="/app/applications/new" className="group inline-flex items-center gap-4" data-testid="broker-new-deal-btn">
          <span className="h-[1px] w-16 bg-slate-800 transition-all group-hover:w-24" />
          <span className="small-caps text-[#1F2937]">Submit New Deal</span>
        </Link>
      </header>

      <section className="hair-y py-10 grid grid-cols-2 lg:grid-cols-4 gap-10">
        <Datum label="Loan Programs Submitted" value={metrics.total_deals ?? 0} />
        <Datum label="Funded" value={metrics.funded_deals ?? 0} />
        <Datum label="Total Funded" value={fmtMoney(metrics.funding_volume || 0)} />
        <Datum label="Est. Commission" value={fmtMoney(metrics.estimated_commission || 0)} sub="150 bps assumed" />
      </section>

      <ReferralLinkCard role="broker" />

      <section>
        <div className="flex items-baseline justify-between">
          <div>
            <div className="small-caps text-slate-500">Submissions</div>
            <h2 className="mt-3 font-semibold text-[36px] text-[#1F2937]">Active book</h2>
          </div>
          <div className="flex items-center gap-6">
            <ViewToggle value={view} onChange={setView} testid="broker-view-toggle" />
            <Link to="/app/applications" className="small-caps text-slate-500 hover:text-[#1F2937]">All submissions →</Link>
          </div>
        </div>
        <div className="mt-4">
          {view === "kanban" ? (
            <KanbanBoard title="" subtitle="" />
          ) : (
            <DealsTable title="" subtitle="Your deals" />
          )}
        </div>
      </section>
    </div>
  );
}
